document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.como-five-swiper').forEach(function (container) {
    var bottomShow = container.querySelector('.bottom_show');
    var leftBtn = container.querySelector('.left-btn');
    var rightBtn = container.querySelector('.right-btn');
    var scrollBar = container.querySelector('.custom-scrollBar');
    var thumb = container.querySelector('.custom-thumb');
    if (!bottomShow || !leftBtn || !rightBtn || !scrollBar || !thumb) return;

    // 滚动到指定百分比
    function scrollToPercent(percent) {
      var maxScroll = bottomShow.scrollWidth - bottomShow.clientWidth;
      bottomShow.scrollLeft = percent * maxScroll;
    }

    // 更新进度条
    function updateThumb() {
      var maxScroll = bottomShow.scrollWidth - bottomShow.clientWidth;
      if (maxScroll <= 0) {
        thumb.style.width = '100%';
        thumb.style.left = '0';
        return;
      }
      var percent = bottomShow.scrollLeft / maxScroll;
      var thumbWidth = (bottomShow.clientWidth / bottomShow.scrollWidth) * 100;
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = percent * (100 - thumbWidth) + '%';
    }

    // 滚动条点击事件
    scrollBar.addEventListener('click', function(e) {
      var rect = scrollBar.getBoundingClientRect();
      var clickX = e.clientX - rect.left;
      var scrollBarWidth = rect.width;
      var percent = clickX / scrollBarWidth;
      
      // 计算可滚动的最大距离
      var maxScroll = bottomShow.scrollWidth - bottomShow.clientWidth;
      var targetScrollLeft = percent * maxScroll;
      
      bottomShow.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    });

    // 按钮点击滑动
    leftBtn.addEventListener('click', function () {
      var card = bottomShow.querySelector('.card');
      if (!card) return;
      var cardWidth = card.offsetWidth + parseInt(getComputedStyle(bottomShow).gap || 0);
      bottomShow.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    });
    rightBtn.addEventListener('click', function () {
      var card = bottomShow.querySelector('.card');
      if (!card) return;
      var cardWidth = card.offsetWidth + parseInt(getComputedStyle(bottomShow).gap || 0);
      bottomShow.scrollBy({ left: cardWidth, behavior: 'smooth' });
    });

    // 滚动时更新进度条
    bottomShow.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);
    setTimeout(updateThumb, 100);

    // 移动端拖动支持
    var isDown = false, startX, scrollLeft;
    bottomShow.addEventListener('pointerdown', function(e) {
      isDown = true;
      bottomShow.classList.add('dragging');
      startX = e.pageX || e.touches?.[0]?.pageX;
      scrollLeft = bottomShow.scrollLeft;
    });
    bottomShow.addEventListener('pointermove', function(e) {
      if (!isDown) return;
      var x = e.pageX || e.touches?.[0]?.pageX;
      var walk = (startX - x);
      bottomShow.scrollLeft = scrollLeft + walk;
    });
    bottomShow.addEventListener('pointerup', function() {
      isDown = false;
      bottomShow.classList.remove('dragging');
    });
    bottomShow.addEventListener('pointerleave', function() {
      isDown = false;
      bottomShow.classList.remove('dragging');
    });
    // 兼容触摸
    bottomShow.addEventListener('touchstart', function(e) {
      isDown = true;
      bottomShow.classList.add('dragging');
      startX = e.touches[0].pageX;
      scrollLeft = bottomShow.scrollLeft;
    });
    bottomShow.addEventListener('touchmove', function(e) {
      if (!isDown) return;
      var x = e.touches[0].pageX;
      var walk = (startX - x);
      bottomShow.scrollLeft = scrollLeft + walk;
    });
    bottomShow.addEventListener('touchend', function() {
      isDown = false;
      bottomShow.classList.remove('dragging');
    });
    bottomShow.addEventListener('touchcancel', function() {
      isDown = false;
      bottomShow.classList.remove('dragging');
    });
  });
}); 